import React,{useEffect,useState} from "react";
import { Link, useParams } from "react-router-dom";
import Master from "./Master";


function Servicedetails(){


  const { id } = useParams();
  const [service, setService] = useState(null);
  const [services, setServices] = useState([]);
  
    useEffect(() => {
      fetch("https://drpatangecitydentalclinic.com/api/latestservice.php")
        .then(res => res.json())
        .then(data => setServices(data));
    }, []);


  useEffect(() => {
    fetch(`https://drpatangecitydentalclinic.com/api/service.php?id=${id}`)
      .then((res) => res.json())
      .then((data) => setService(data));
  }, [id]);

  if (!service) return <h2>Loading...</h2>;


    return(
        <Master>
    {/* Page Header Start */}
	<div className="page-header">
		<div className="container">
			<div className="row">
				<div className="col-lg-12">
					{/* Page Header Box Start */}
					<div className="page-header-box">
						<h1 className="text-anime-style-2" data-cursor="-opaque"><span>{service.name}</span></h1>
						<nav className="wow fadeInUp">
							<ol className="breadcrumb">
								<li className="breadcrumb-item"><a href="/">home</a></li>
								<li className="breadcrumb-item"><Link to={"/service"}>our services</Link></li>
								<li className="breadcrumb-item active" aria-current="page">{service.name}</li>
							</ol>
						</nav>
					</div>
					{/* Page Header Box End */}
				</div>
			</div>
		</div>
	</div>
	{/* Page Header End */}

    {/* Page Service Single Start */}
    <div className="page-service-single">
        <div className="container">
            <div className="row">
                <div className="col-lg-4">
                    {/* Service Sidebar Start */}
                    <div className="service-sidebar">
                        {/* Service Categories List Start */}
                        <div className="service-catagery-list wow fadeInUp">
                            <h3>our services</h3>
                            <ul>
                                {services.map((item, index) => (
                                <li  key={item.id}><Link to={`/servicedetails/${item.id}`}>{item.name}</Link></li>
                                ))}

                            </ul>
                        </div>
                        {/* Service Categories List End */}

                        {/* Sidebar Cta Box Start */}
                        <div className="sidebar-cta-box wow fadeInUp" data-wow-delay="0.25s">
                            {/* Cta Content Start */}
                            <div className="icon-box">
                                <img src="/images/icon-cta.svg" alt=""/>
                            </div>

                            <div className="cta-content">
                                <h3>Need help ?</h3>
                                <p>Schedule your initial consultation today and start your journey towards a pain-free, healthier smile. Contact us now!</p>
                            </div>
                            {/* Cta Content End */}

                            {/* Cta Appointment Button Start */}
                            <div className="cta-contact-btn">
                                <Link to={"/contact"} className="btn-default">contact us</Link>
                            </div>
                        {/* Cta Appointment Button End */}
                        </div>
                        {/* Sidebar Cta Box End */}
                    </div>
                    {/* Service Sidebar End */}
                </div>

                <div className="col-lg-8">
                    {/* Service Single Content Start */}
                    <div className="service-single-content">
                        {/* Service Featured Image Start */}
                        <div className="service-featured-image">
                            <figure className="reveal image-anime">
                        <img src={`https://drpatangecitydentalclinic.com/uploads/${service.image}`} alt={service.name} />
                            </figure>
                        </div>
                        {/* Service Featured Image End */}

                        {/* Service Entry Content Start */}
                        <div className="service-entry">
                            <h3 className="wow fadeInUp">{service.title}</h3>
                            <p className="wow fadeInUp" data-wow-delay="0.2s">{service.details}</p>
                            
                            <ul className="wow fadeInUp" data-wow-delay="1s">
                                <li>experienced team</li>
                                <li>comprehensive services</li>
                                <li>state-of-the-art technology</li>
                                <li>emergency dental services</li>
                            </ul>
                        </div>
                        {/* Service Entry Content End */}
                    </div>
                    {/* Service Single Content End */}

                    {/* Service Accordian Start */}
                    <div className="service-faqs">
                        <div className="faqs-section-title">
                            <h2 className="text-anime-style-2" data-cursor="-opaque">Frequently Asked Questions</h2>
                        </div>

                        {/* FAQ Accordion Start */}
                        <div className="faq-accordion" id="accordion">
                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp">
                                <h2 className="accordion-header" id="heading1">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                                        what is orthodontics?
                                    </button>
                                </h2>
                                <div id="collapse1" className="accordion-collapse collapse show" aria-labelledby="heading1"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>Orthodontics is a dental specialty focused on diagnosing, preventing, and treating dental and facial irregularities, such as misaligned teeth and jaws.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}

                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp" data-wow-delay="0.25s">
                                <h2 className="accordion-header" id="heading2">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                                        what are dental sealants?
                                    </button>
                                </h2>
                                <div id="collapse2" className="accordion-collapse collapse" aria-labelledby="heading2"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>Dental sealants are thin, protective coatings applied to the chewing surfaces of molars to prevent cavities.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}

                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp" data-wow-delay="0.5s">
                                <h2 className="accordion-header" id="heading3">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                                        are teeth whitening treatments safe?
                                    </button>
                                </h2>
                                <div id="collapse3" className="accordion-collapse collapse" aria-labelledby="heading3"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>Yes, teeth whitening treatments performed by a dentist or with dentist-approved products are safe and effective.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}

                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp" data-wow-delay="0.75s">
                                <h2 className="accordion-header" id="heading4">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                                        what is cosmetic dentistry?
                                    </button>
                                </h2>
                                <div id="collapse4" className="accordion-collapse collapse" aria-labelledby="heading4"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>Cosmetic dentistry focuses on improving the appearance of teeth, gums, and smile through procedures like whitening, veneers, and bonding.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}

                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp" data-wow-delay="1s">
                                <h2 className="accordion-header" id="heading5">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                                        how can i whiten my teeth at home?
                                    </button>
                                </h2>
                                <div id="collapse5" className="accordion-collapse collapse" aria-labelledby="heading5"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>At-home whitening options include over-the-counter whitening strips, gels, toothpaste, and custom trays provided by your dentist.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}
                        </div>
                        {/* FAQ Accordion End */}
                    </div>
                    {/* Service Accordian End */}
                </div>
            </div>
        </div>
    </div>
    {/* Page Service Single End */}
        </Master>
    );
}

export default Servicedetails;